const moment = require("moment");
/**
 * @module app.prospection.store.updateBusinessCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function UpdateBusinessCtrl(
        $scope,
        $rootScope,
        $uibModalInstance,
        storeService,
        business,
        scenarioType,
        orderType,
        storeActivity,
        status,
        users,
        store
    ) {
        let self = {};
        self.business = business[0];
        self.business.dateFinContrat =  self.business.dateFinContrat === null ? storeService.getDateFinContrat(store) : self.business.dateFinContrat;
        self.dateFinContrat = new Date(moment(self.business.dateFinContrat).format('YYYY-MM-DD')) || null;
        self.moisSignature = new Date(moment(self.business.moisSignature).format('YYYY-MM-DD'));
        self.moisRelance = new Date(moment(self.business.moisRelance).format('YYYY-MM-DD'));
        self.dateRdv = new Date(moment(self.business.dateRdv).format('YYYY-MM-DD HH:mm'));

        self.orderType = orderType;
        self.scenarioType = scenarioType;
        self.storeActivity = storeActivity;
        self.status = status;
        self.users = users;
        self.gestionnaire = self.users.filter(
            tel => (tel.role === 'TELEPRO' || tel.role === 'CS' || tel.role === 'RDS') && tel.displayName !== null
        );
        self.gestionnaire.push($rootScope.user);

        // on surveille si la DFC change
        self.store = store;
        self.fieldsToWatchModifications = {};

        if (self.business.businessStatusId !== 3) {
            self.status = self.status.filter(status => status.id !== 3);
        }

        self.isDisabled = [3, 4, 5, 6].includes(self.business.businessStatusId);


        self.send = function() {
            let user = self.users.filter(user => user.uid === self.business.userIdRef);
            self.business.userRef = user[0].displayName;
            self.business.managerRefId = user[0].parent;
            self.business.dateFinContrat = self.dateFinContrat
                ? moment(self.dateFinContrat).format('YYYY-MM-DD')
                : null;
            self.business.moisSignature = self.moisSignature ? moment(self.moisSignature).format('YYYY-MM-DD') : null;
            self.business.moisRelance = self.moisRelance ? moment(self.moisRelance).format('YYYY-MM-DD') : null;
            self.business.dateRdv = self.dateRdv ? moment(self.dateRdv).format('YYYY-MM-DD HH:mm') : null;
            if(self.store.identifiant_magasin) {
                self.store.qualification.fin_contrat = self.dateFinContrat
                    ? new Date(moment(self.dateFinContrat).format('YYYY-MM-DD'))
                    : null;
                _updateFieldToWatch('dateEndContract', self.store.qualification.fin_contrat, 'date');
                self.store.fieldsToWatch = self.fieldsToWatchModifications;
            }

            $uibModalInstance.close({
                business: self.business,
                store: self.store
            });
        };

        self.delete = () => {
            if(confirm('Êtes-vous sûr de vouloir supprimer l\'affaire?')) {
                $uibModalInstance.close({
                    business: self.business,
                    delete: true
                });
            }else{
                self.cancel();
            }
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        self.updateStatusLabel = function() {
            let status = self.status.find(status => status.id === self.business.businessStatusId);
            self.business.businessStatusLabel = status.businessStatusLabel;
            self.business.dateModificationStatus =
                self.business.businessStatusId > 2 ? moment().format('YYYY-MM-DD HH:mm') : null;
        };

        /**
         * Set the fields to watch
         * @param {Array} fields : [
         *   {field : string, value: *, label : string, type : string}
         * ]
         * field : field to watch modifications
         * label : label to display in the email
         * value : the current value of the watched field
         * type  : the type of the field. Only the type date is defined.
         */
        function _setFieldsToWatch(fields) {
            let fieldsLength = fields.length;
            let type, value;
            for (let i = 0; i < fieldsLength; i++) {
                type = fields[i].type ? fields[i].type : null;
                value =
                    type && type === 'date' && fields[i].value
                        ? moment(fields[i].value).format('YYYY-MM-DD')
                        : fields[i].value;

                self.fieldsToWatchModifications[fields[i].field] = {
                    label: fields[i].label,
                    new: null,
                    old: value
                };
            }
        }

        /**
         * Update a field to watch modifications
         * @param  {String} field
         * @param  {*} newValue
         * @param  {String} type
         */
        function _updateFieldToWatch(field, newValue, type) {
            let value = newValue;
            field = self.fieldsToWatchModifications[field];

            if (value) {
                if (type && type === 'date') {
                    value = moment(value).format('YYYY-MM-DD');
                }
            }

            if (value !== field.old) {
                field.new = value;
            }
        }
        if(self.store.identifiant_magasin){
            _setFieldsToWatch([
                {
                    field: 'dateEndContract',
                    value: self.store.qualification.fin_contrat,
                    label: 'Date de fin de contrat',
                    type: 'date'
                }
            ]);
        }


        return self;
    }

    UpdateBusinessCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'storeService',
        'business',
        'scenarioType',
        'orderType',
        'storeActivity',
        'status',
        'users',
        'store'
    ];

    angular
        .module('app.prospection.store.updateBusinessCtrl', ['ui.bootstrap'])
        .controller('UpdateBusinessCtrl', UpdateBusinessCtrl);
});
